import React, { useState } from 'react';
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;
// const backendUrl = 'http://127.0.0.1:8000/';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch(`${backendUrl}login/login/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem('access_token', data.access);
        localStorage.setItem('refresh_token', data.refresh);
        localStorage.setItem('user_id', data.user.id);
        localStorage.setItem('full_name', data.user.full_name || '');
        localStorage.setItem('email', data.user.email || '');
        localStorage.setItem('role', data.user.role); // ADDED!
        localStorage.setItem('role_name', data.user.role_name || data.user.role || '');
        // Dynamic RBAC: the permission codes this user's role grants, and the
        // full list of role codes that currently exist (so brand-new custom
        // roles created from the Roles & Permissions screen are recognised
        // by ProtectedRoute/Sidebar without a frontend code change).
        localStorage.setItem('permissions', JSON.stringify(data.user.permissions || []));
        localStorage.setItem('is_superuser', data.user.is_superuser ? 'true' : 'false');
        localStorage.setItem('all_role_codes', JSON.stringify(data.all_role_codes || []));
        localStorage.setItem('isLoggedIn', 'true');
        const lastVisitedPage = localStorage.getItem('lastVisitedPage');
        if (lastVisitedPage) localStorage.removeItem('lastVisitedPage');
        navigate(lastVisitedPage || '/');
      } else {
        setError(data.detail || data.error || 'Invalid email or password!');
      }
    } catch (err) {
      setError('Something went wrong!');
      console.error('Login error:', err);
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
      }}
    >
      {/* <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: 1,
          zIndex: -1,
        }}
      >
        <source src="/login.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video> */}
      <img
        src="/view.jpg"
        alt="Background"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: 1,
          zIndex: -1,
        }}
      />


      <div
        style={{
          width: '100%',
          maxWidth: '500px',
          backgroundColor: '#ffffffe6',
          opacity: 0.9,
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '1rem',
          boxShadow: '0 0 15px 3px rgba(0, 0, 0, 0.1)',
          padding: '2rem',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '1rem',
              marginBottom: '1.5rem',
              flexWrap: 'wrap',
            }}
          >


            <img
              src="/timor.png"
              alt="Timor Logo"
              style={{ width: '60px', height: '60px', objectFit: 'contain' }}
            />

            <img
              src="/dnmg1.png"
              alt="Meteorology Logo"
              style={{ width: '60px', height: '60px', objectFit: 'contain' }}
            />

            <img
              src="/DNMG_NEW.png"
              alt="DNMG Logo"
              style={{ width: '60px', height: '60px', objectFit: 'contain' }}
            />

            <h1
              style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: '#111827',
                margin: 0,
              }}
            >
              Disaster Risk Reduction Decision Support System
            </h1>
          </div>
        </div>

        <form
          onSubmit={handleLogin}
          style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                color: '#374151',
                fontSize: '0.875rem',
                fontWeight: '500',
              }}
            >
              <FaUser size={16} style={{ color: '#9ca3af' }} />
              Email Address
            </label>
            <input
              id="email"
              type="email"
              placeholder="admin@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                height: '3rem',
                padding: '0.75rem',
                borderRadius: '0.75rem',
                border: '1px solid #d1d5db',
                outline: 'none',
                fontSize: '0.875rem',
                backgroundColor: 'rgba(255, 255, 255, 0.82)',
                backdropFilter: 'blur(4px)',
                boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.05)',
              }}
            />
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem',
              position: 'relative',
            }}
          >
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                color: '#374151',
                fontSize: '0.875rem',
                fontWeight: '500',
              }}
            >
              <FaLock size={16} style={{ color: '#9ca3af' }} />
              Password
            </label>
            <input
              id="password"
              type={showPassword ? 'text' : 'password'}
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                height: '3rem',
                padding: '0.75rem 2.5rem 0.75rem 0.75rem',
                borderRadius: '0.75rem',
                border: '1px solid #d1d5db',
                outline: 'none',
                fontSize: '0.875rem',
                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                backdropFilter: 'blur(4px)',
                boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.05)',
              }}
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              style={{
                position: 'absolute',
                right: '0.75rem',
                top: '65%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#9ca3af',
              }}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
            </button>
          </div>

          <div style={{ textAlign: 'right', marginTop: '-1rem' }}>
            <a
              href="/ForgotPassword"
              style={{ color: '#4f46e5', textDecoration: 'none', fontWeight: '500', fontSize: '0.8125rem' }}
              onClick={(e) => {
                e.preventDefault();
                navigate('/ForgotPassword');
              }}
            >
              Forgot password?
            </a>
          </div>

          {error && (
            <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.5rem' }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            style={{
              width: '100%',
              height: '3rem',
              background: 'linear-gradient(to right, #4f46e5, #a855f7)',
              color: 'white',
              fontWeight: '600',
              borderRadius: '0.75rem',
              border: 'none',
              cursor: 'pointer',
              fontSize: '0.875rem',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.2s',
            }}
          >
            Sign in
          </button>

          <div style={{ textAlign: 'center', marginTop: '0.2rem' }}>
            <p style={{ color: '#374151', fontSize: '0.875rem' }}>
              Don't have an account?{' '}
              <a
                href="/SignupPage"
                style={{ color: '#4f46e5', textDecoration: 'none', fontWeight: '500' }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/SignupPage');
                }}
              >
                Register here
              </a>
            </p>
          </div>
        </form>

        <div style={{ marginTop: '0rem', textAlign: 'center' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '1rem',
              marginBottom: '1rem',
            }}
          >
            <div
              style={{
                width: '45px',
                height: '45px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img src="/LoginPage/UNEP.svg" alt="UNEP Logo" style={{ width: '100%', height: '100%' }} />
            </div>
            <div
              style={{
                width: '45px',
                height: '45px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img src="/LoginPage/RIMES.svg" alt="RIMES Logo" style={{ width: '100%', height: '100%' }} />
            </div>
            <div
              style={{
                width: '80px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img src="/LoginPage/GCF.svg" alt="GCF Logo" style={{ width: '100%', height: '100%' }} />
            </div>
          </div>
          <p style={{ color: '#6b7280', fontSize: '0.75rem' }}>
            Supported by UN Environment Programme, RIMES, and Green Climate Fund
          </p>
        </div>
      </div>
    </div>
  );
  // ...rest remains unchanged (UI/inputs/buttons)
};

export default LoginPage;
